module.exports = __webpack_public_path__ + "static/media/super_pack_en_chat_automne.1b9a35db.png";